import { TouchpadOff } from 'lucide-react'
import { FC, memo } from 'react'

import { TableCell, TableRow } from '../Table'
import { Spin } from '@fp/ui-kit'
import { iconStroke } from '@lib/iconProps'

type LoadingEmptyTableProps = {
  isLoading?: boolean
  columnsLength?: number
  emptyText?: string
}

export const EmptyTable: FC<LoadingEmptyTableProps> = memo(
  ({ isLoading = false, columnsLength = 100, emptyText = 'No data' }) => (
    <tr
      className={`flex flex-row justify-center col-span-full bg-muted rounded-xl mt-2 py-12 animate-fade-in ${isLoading ? 'animate-pulse' : ''}`}
    >
      <td colSpan={columnsLength} className='bg-muted text-muted-foreground text-lg flex flex-row items-center gap-2'>
        {isLoading ? (
          <>
            <Spin size='lg' />
            Loading...
          </>
        ) : (
          <>
            <TouchpadOff strokeWidth={iconStroke.thin} className='size-8' />
            {emptyText}
          </>
        )}
      </td>
    </tr>
  ),
)

export const EmptyTableSimple = ({ columnsLength, emptyText }: { columnsLength: number; emptyText: string }) => (
  <TableRow>
    <TableCell colSpan={columnsLength} className='bg-muted/50 text-muted-foreground text-lg py-12 justify-items-center'>
      <div className='flex flex-row items-center justify-center gap-2'>
        <TouchpadOff className='size-8' strokeWidth={iconStroke.thin} /> {emptyText}
      </div>
    </TableCell>
  </TableRow>
)
